import React from 'react'
import styled from 'styled-components'
import { assetPrefix } from 'config/env_config'
import withRootContext from 'context/withRootContextHOC'

const LoaderDiv = styled.div`
    height: 100%;
    width: 100%;
    background: #0000003f;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed !important;
    left:0;
    top:0;
    z-index: 2000;
`

const Loader = (props) => {
  return (
    props.context.isLoading &&
      <LoaderDiv data-test='loaderDiv'>
        <img src={`${assetPrefix}/static/images/spinner.svg`} />
      </LoaderDiv>
  )
}

export default withRootContext(Loader)
